export default "__VITE_ASSET__Deel3dQh__"